module.exports = __webpack_public_path__ + "static/media/close-right-section.be352620.svg";